import { BookingCalendar } from './BookingCalendar'

export class BookingFront {
  BookingCalendar: BookingCalendar

  constructor() {
    this.BookingCalendar = new BookingCalendar({ container: document.querySelectorAll('.booking-calendar') })
    this.BookingCalendar.appendCalendar()
  }
}
